import { FC } from 'react';

import Button from '../Button';
import { StyledFooter } from './DatePicker.styled';

export interface DatePickerFooterProps {
  onCancel: () => void;
  onConfirm: () => void;
  confirmDisabled?: boolean;
  onReset?: () => void;
  resetDisabled?: boolean;
}

const DatePickerFooter: FC<DatePickerFooterProps> = ({
  onCancel,
  onConfirm,
  confirmDisabled,
  onReset,
  resetDisabled,
}) => (
  <StyledFooter>
    {onReset && (
      <Button
        color="tertiary"
        variant="ghost"
        size="md"
        fullWidth
        onClick={onReset}
        disabled={resetDisabled}
      >
        Reset
      </Button>
    )}
    <Button color="primary" variant="outline" size="md" fullWidth onClick={onCancel}>
      Cancel
    </Button>
    <Button
      color="primary"
      variant="solid"
      size="md"
      fullWidth
      onClick={onConfirm}
      disabled={confirmDisabled}
    >
      Confirm
    </Button>
  </StyledFooter>
);

DatePickerFooter.displayName = 'DatePickerFooter';

export default DatePickerFooter;
